export default "__VITE_ASSET__BROHFgZy__"